import React from 'react';

interface OverlayProps {
  /** Whether the overlay is visible */
  open: boolean;
  /** z-index. Defaults to 200. */
  z?: number;
  /** Content rendered inside the modal card */
  children: React.ReactNode;
}

/**
 * Full-screen modal overlay used for onboarding, approval-gate, and
 * account-state screens (Deactivated / NoAccess / Completion / Rejected /
 * Verified). Renders the shared chrome: fixed backdrop + centered card.
 */
const Overlay: React.FC<OverlayProps> = ({ open, z = 200, children }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-white/50 backdrop-blur-sm p-2 sm:p-4"
      style={{ zIndex: z }}
    >
      <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col transition-all duration-300 w-full h-full sm:w-full sm:h-[96vh]">
        {children}
      </div>
    </div>
  );
};

export default Overlay;
